export const AdminNavItems = [
    {
        title: "dashboard",
        url: "/admin/dashboard",
        cName: "navLink",
    },
    {
        title: "syllabus",
        url: "/admin/syllabus",
        cName: "navLink",
    },
    // {
    //     title: "Questions",
    //     url: "/admin/questions",
    //     cName: "navLink",
    // },
    {
        title: "liveclass",
        url: "/admin/liveclass",
        cName: "navLink",
    },
    {
        title: "members",
        url: "/admin/members",
        cName: "navLink",
    },
    {
        title: "tests",
        url: "/admin/tests",
        cName: "navLink",
    },
    // {
    //     title: "Analytics",
    //     url: "/admin/analytics",
    //     cName: "navLink",
    // },
    {
        title: "profile",
        url: "/admin/profile",
        cName: "navLink",
    }
]